import React, { Suspense, lazy } from 'react'
import { render } from 'react-dom'
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom'
import { Provider } from 'react-redux'
import store from './store'
import SuspenseLoader from './components/suspense_loader/SuspenseLoader'
import Navigation from './navigation/Navigation'
import ScrollToTop from './navigation/ScrollToTop'
import RouteListener from './navigation/RouteListener'

import './utils/scss/global.scss'

const Standings = lazy(() => import('./containers/standings/Standings'))
const Players = lazy(() => import('./containers/players/Players'))
const Search = lazy(() => import('./containers/search/Search'))
const Stats = lazy(() => import('./containers/stats/Stats'))
const Videos = lazy(() => import('./containers/videos/Videos'))
const Livetrackers = lazy(() => import('./containers/livetrackers/Livetrackers'))
const Scoreboard = lazy(() => import('./containers/scoreboard/Scoreboard'))
const Team = lazy(() => import('./containers/team/Team'))
const PlayerProfile = lazy(() => import('./containers/player_profile/PlayerProfile'))
const AncillarySport = lazy(() => import('./containers/ancillary_sport/AncillarySport'))
const AncillaryLeague = lazy(() => import('./containers/ancillary_league/AncillaryLeague'))
const HockeyTournament = lazy(() => import('./containers/tournaments/hockey/HockeyTournament'))
const Schedule = lazy(() => import('./containers/schedule/Schedule'))
const PlayoffTracker = lazy(() => import('./containers/playoff_tracker/PlayoffTracker'))
const NotFoundGeneral = lazy(() => import('./components/NotFoundGeneral'))
const TradeSigningsTracker = lazy(() => import('./containers/trade_signings_tracker/TradeSigningsTracker'))

const router = (
    <Provider store={store}>
        <Router>
            <ScrollToTop>
                <RouteListener>
                    <Route path="/:sport?/:league?" component={Navigation} />
                    <Suspense fallback={<SuspenseLoader />}>
                        <Switch>
                            <Route exact path="/:sport/:league/stats" component={Stats} />
                            <Route exact path="/:sport/:league/players" component={Players} />
                            <Route exact path="/:sport/:league/standings" component={Standings} />
                            <Route
                                exact
                                path="/:sport/:league/playoffs"
                                component={PlayoffTracker}
                            />
                            <Route
                                exact
                                path="/:sport/:league/:page(trade-tracker|signings)"
                                component={TradeSigningsTracker}
                            />
                            <Route
                                exact
                                path="/:sport/:league/games/:gamecode"
                                component={Livetrackers}
                            />
                            <Route
                                exact
                                path="/:sport/:league/players/:player_name/:player_id"
                                component={PlayerProfile}
                            />

                            <Redirect
                                exact
                                from="/:sport(golf|ufc|tennis|auto-racing)/:league/"
                                to="/:sport(golf|ufc|tennis|auto-racing)/:league/schedule"
                            />
                            <Route
                                exact
                                path="/:sport(golf|ufc|tennis|auto-racing)/:league/:page(schedule|results|rankings|events)/:id?"
                                component={AncillaryLeague}
                            />

                            <Route
                                exact
                                path="/:sport/:league/scores/:day?"
                                component={Scoreboard}
                            />
                            <Route
                                exact
                                path="/:sport/:league/teams/:teamName/:teampage?"
                                component={Team}
                            />
                            <Route
                                exact
                                path="/videos/:sport?/:league?/:slug?"
                                component={Videos}
                            />
                            <Route
                                exact
                                path="/soccer/:leagueOrSubPage/:dayOrSubPage?"
                                component={props => <AncillarySport sport="soccer" {...props} />}
                            />
                            <Route
                                exact
                                path="/juniors/world-juniors/:day?"
                                component={props => (
                                    <HockeyTournament sport="juniors" league="wjc" {...props} />
                                )}
                            />
                            <Route
                                exact
                                path="/juniors/:leagueOrSubPage/:dayOrSubPage?"
                                component={props => <AncillarySport sport="juniors" {...props} />}
                            />
                            <Route exact path="/schedule/:day?" component={Schedule} />
                            <Route exact path="/search/:keyword?" component={Search} />
                            <Route component={NotFoundGeneral} />
                        </Switch>
                    </Suspense>
                </RouteListener>
            </ScrollToTop>
        </Router>
    </Provider>
)

render(router, document.getElementById('root'))
